<template>
  <withTopNav leftText="Regras de Rebate" class="text-13" fixed>
    <div class="detail">
      <div
        class="inline-flex items-center px-4 py-3 text-white text-[16px] self-start"
        @click="changeCascaderVisible"
      >
        <span>{{ category.name }}</span>
        <div class="mx-2 w-3 h-[2px] bg-[#D9D9D9]"></div>
        <span>{{ room.gameRoom }}</span>
        <Image
          :src="downArrowIcon"
          :class="['w-3 h-[6px] ml-[6px]', { 'rotate-[180deg]': cascaderModal }]"
        />
      </div>

      <!-- 投注返现率表格 -->
      <div class="px-4">
        <DataTable :columns="columns" :round="true" :data="roomRateList"></DataTable>
      </div>

      <!-- 不参与游戏列表 -->
      <div class="px-4 pt-5 flex-grow flex flex-col pb-8">
        <div class="flex items-center h-[44px] rounded-lg bg-[#2C7952]/70">
          <Image :src="activity_triangle_tip" class="w-6 h-6 mx-3" />
          <span class="text-white text-[15px]"> Jogos Excluídos do Rebate </span>
        </div>
        <div class="flex-grow py-2">
          <template v-if="excludeGameList.length">
            <div class="grid grid-cols-2 gap-2.5">
              <div v-for="(item, index) in excludeGameList" :key="item.name">
                <div
                  :class="[
                    'h-10 relative rounded-sm w-full overflow-hidden',
                    index % 4 === 0 || index % 4 === 1
                      ? '!bg-[#2C7952]/40'
                      : '!bg-[#2C7952]/20',
                  ]"
                >
                  <Image :src="item.icon" class="w-[33px] h-full absolute left-0 top-0" />
                  <div class="h-full ml-12 flex items-center">
                    <div class="text-sm text-white line-clamp-2 text-ellipsis">
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-if="excludeGameList.length === 0">
            <NoData />
          </template>
        </div>
      </div>
      <!-- 分类厅室过滤器 -->
      <van-popup
        v-model:show="cascaderModal"
        position="bottom"
        class="w-full bg-[#151A1F] bottom-0 rounded-t-[24px]"
      >
        <div
          class="w-full h-11 text-[15px] flex justify-center items-center bg-[#2C7952]/70 text-white sticky top-0 rounded-t-[20px]"
        >
          Condições de Filtro
        </div>
        <p class="text-[#fff] text-[17px] my-3 px-4">Filtrar jogos</p>
        <div class="flex px-4 h-[350px]">
          <div class="w-28 overflow-y-scroll">
            <div
              v-for="item in cascaderRoomList"
              :key="item.name"
              @click="
                () => {
                  currentCategoryName = item.name;
                  currentRoomName = '';
                }
              "
              :class="[
                'text-[13px] h-11 leading-[44px] text-center rounded-lg mb-4',
                currentCategoryName === item.name
                  ? 'text-white bg-[#2C7952]'
                  : 'text-white/75 bg-[#2C7952]/40',
              ]"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="flex-grow overflow-y-scroll ml-4">
            <div
              v-for="item in currentRoomList"
              :key="item.gameRoom"
              @click="
                () => {
                  currentRoomName = item.gameRoom;
                }
              "
              :class="[
                'text-[13px] h-11 leading-[44px] text-center rounded-lg mb-4',
                currentRoomName === item.gameRoom
                  ? 'bg-[#2C7952]/70 text-white'
                  : 'bg-[#2C7952]/20 text-white/50',
              ]"
            >
              {{ item.gameRoom }}
            </div>
          </div>
        </div>

        <div class="mx-4">
          <PopupFooter
            @cancel="cascaderModal = false"
            @confirm="
              () => {
                if (currentRoomName) {
                  changeRoom(
                    currentRoomList.find((item) => item.gameRoom === currentRoomName)
                  );
                }
              }
            "
          />
        </div>
      </van-popup>
    </div>
  </withTopNav>
</template>

<script setup lang="tsx">
import withTopNav from "@/layouts/withTopNav.vue";
import downArrowIcon from "./images/downArrowIcon.png";
import DataTable from "@a/components/DataTable/index.vue";
import NoData from "@/components/NoData/index.vue";
import PopupFooter from "@a/components/PopupFooter/index.vue";
import activity_triangle_tip from "./images/activity_triangle_tip.png";
import { getExcludeGameList } from "@/api/rebate";
const route = useRoute();
const activityId = route.query.activityId;
const { currentRoom = {}, currentCategory = {}, gameCategorys = [] } = history.state;
const cascaderModal = ref(false);
const currentCategoryName = ref(currentCategory.name);
const currentRoomName = ref(currentRoom.gameRoom);
const category = ref<any>(currentCategory);
const room = ref<any>(currentRoom);
const roomRateList = ref<any[]>(currentRoom.rewardConfigInfos);
const excludeGameList = ref<any[]>([]);
const loading = ref(false);
const cascaderRoomList = ref<any[]>([]);
const currentRoomList = ref<any[]>([]);
const columns = [
  {
    title: "Apostas Válidas",
    key: "requireBet",
    render: (row: any) => (
      <div class="text-13 flex-center size-full">{row.requireBet}</div>
    ),
  },
  {
    title: "Taxa de Rebate",
    key: "proportion",
    render: (row: any) => (
      <div class="text-13 flex-center size-full text-[#64F765]">{row.proportion}%</div>
    ),
  },
];
// 生成分类厅室列表
const genCascaderRoomList = async () => {
  const result = await Promise.all(
    gameCategorys.map(async (item) => {
      const children: any = item.detailList;
      return {
        ...item,
        _key: item.id,
        children: children.map((cItem) => ({
          ...cItem,
          _key: `${item.name}-${cItem.gameRoom}`,
        })),
      };
    })
  );
  cascaderRoomList.value = result;
  currentRoomList.value =
    cascaderRoomList.value.find((item) => item.name === currentCategoryName.value)
      ?.children || [];
};
// 切换房间
const changeRoom = (item: any) => {
  if (item.gameRoom === room.value.gameRoom) {
    cascaderModal.value = false;
    return;
  }
  room.value = item;
  roomRateList.value = item.rewardConfigInfos;
  const categoryItem = cascaderRoomList.value.find(
    (item) => item.name === currentCategoryName.value
  );
  category.value = categoryItem;
  excludeGameList.value = [];
  cascaderModal.value = false;
};
// 分类厅室过滤器
const changeCascaderVisible = () => {
  cascaderModal.value = true;
  currentCategoryName.value = category.value.name;
  currentRoomName.value = room.value.gameRoom;
};

const getExcludeGameListData = async () => {
  loading.value = true;
  const result = await getExcludeGameList({
    categoryName: category.value.name,
    roomName: room.value.gameRoom,
    activityId,
  });
  if (result.code === 1) {
    excludeGameList.value = result.data;
    loading.value = false;
  }
};
// 监听分类厅室变化
watch([() => category.value.name, () => room.value.gameRoom], () => {
  getExcludeGameListData();
});
// 监听分类厅室变化
watch(currentCategoryName, () => {
  currentRoomList.value =
    cascaderRoomList.value.find((item) => item.name === currentCategoryName.value)
      ?.children || [];
});

onMounted(() => {
  genCascaderRoomList();
  getExcludeGameListData();
});
</script>

<style lang="scss" scoped></style>
